export const RGBAFromRGBAString = (colorString: string) => {
  const hexColor = colorString.replace("#", "");
  return {
    red: parseInt(hexColor.substring(0, 2), 16),
    green: parseInt(hexColor.substring(2, 4), 16),
    blue: parseInt(hexColor.substring(4), 16),
    opacity: 1,
  };
};